import { Ng2StateDeclaration, StatesModule, Transition } from '@uirouter/angular';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { AccessRightType, ApplicationSettingsType } from '@fi-shared/types';
import { FiChecklist2ReportComponent } from '@fi-shared/checklist/fi-checklist2-report/fi-checklist2-report.component';

const auditMode = true;

const ChecklistV2AuditReportState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2Audit.Report._name,
    url: '/Report',
    abstract: true,
    component: FiAbstractStateComponent,
};

const ChecklistV2AuditReportDashboardState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2Audit.Report.Dashboard,
    url: '/Dashboard',
    params: {
        reloadData: null,
        checklistId: null,
        scheduleId: null,
        reportType: null,
    },
    component: FiChecklist2ReportComponent,
    reloadOnSearch: false,
    resolve: {
        //reloadData: [FiStateService, Transition, dashBoardState_reloadData],
        auditMode: [() => auditMode],
    },
};

export const ChecklistV2AuditReportStates: StatesModule = {
    states: [ChecklistV2AuditReportState, ChecklistV2AuditReportDashboardState],
};

export function registerChecklistV2AuditReportStateRules(stateAccessCheckService: StateAccessCheckService) {
    stateAccessCheckService.registerStateRules([FiStateNames.ChecklistV2Audit.Report._name], {
        SettingType: [ApplicationSettingsType.ChecklistV2AuditReports],
        AccessType: AccessRightType.Read,
    });
    stateAccessCheckService.registerStateRules([FiStateNames.ChecklistV2Audit.Report.Dashboard], {
        SettingType: [ApplicationSettingsType.ChecklistV2AuditReports],
        AccessType: AccessRightType.Read,
    });
}
